import { useAppContext } from 'Context/AppContext';
import { PaidBillList, UnpaidBillList, CancelledBillHistoryList } from './Tabs';

export * from './Tabs/PendingApprovalBillList';

export const BillList = () => {
  const { tabNumber } = useAppContext();

  if (tabNumber === 0) return <UnpaidBillList />;
  if (tabNumber === 1) return <PaidBillList />;
  if (tabNumber === 2) return <CancelledBillHistoryList />;

  return <></>;
};
